module.exports = __webpack_public_path__ + "img/einstein@2x.01667d16.png";